import { PayloadAction } from '@reduxjs/toolkit';
import { DTOSearchSettings } from '@shared/dto/search/dto_search_settings';
import { ENUM__redux_action } from '../_base/ENUM__redux_action';
import { StateSearch } from './state_search';

export const local_search_delete = (payload: string[]): PayloadAction<string[]> => ({
  type: ENUM__redux_action.SEARCH_DELETE,
  payload: payload,
});

export const init_local_search_delete = (state: StateSearch, action: PayloadAction<string[]>) => {
  if (action.payload.is_empty()) return;

  for (let id of action.payload) {
    if (state.search_current._id == id) {
      state.search_current = DTOSearchSettings.CREATE_STUB();
    }

    state.search_history_map.delete(id);
  }

  //need refresh map to trigger re-render
  state.search_history_map = new Map(state.search_history_map);
};
